import { useEffect, useState } from 'react';

import { getHQSetting, setHQSetting } from '../utils/index.js';

const useHQ = (cameraId: string) => {
  const [isHQ, setIsHQ] = useState<boolean>(getHQSetting(cameraId));

  const setQualitySettingsValues = (): void => {
    setIsHQ(!isHQ);
    setHQSetting(cameraId, !isHQ);
  };

  // sets correct initial value for isHQ.
  useEffect(() => {
    setIsHQ(getHQSetting(cameraId));
  }, [cameraId]);

  return {
    isHQ,
    setIsHQ: setQualitySettingsValues,
  };
};

export default useHQ;
